export default "__VITE_ASSET__BG$XOKop__"